import { render, staticRenderFns } from "./PEComponentCreator.vue?vue&type=template&id=bdd7b8b4"
import script from "./PEComponentCreator.vue?vue&type=script&lang=js"
export * from "./PEComponentCreator.vue?vue&type=script&lang=js"
import style0 from "./PEComponentCreator.vue?vue&type=style&index=0&id=bdd7b8b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports